import React, { useEffect, useState } from 'react';

import InputWrapper, { getWrapperProps } from 'components/layout/InputWrapper';
import SearchInput from 'components/layout/SearchInput';

const Searchbar = (props) => {
  const { params, alwaysExpand, searchSize, className, fullWidth, disabled } = props;
  const [search, setSearch] = useState();

  const wrapperProps = getWrapperProps(props);

  useEffect(() => {
    const searchDelay = setTimeout(() => {
      if (search !== params.get('search') && params.get('page')) {
        params.setFew([
          { key: 'search', value: search },
          { key: 'page', value: '1' }
        ]);
      } else if (search !== params.get('search')) {
        params.set('search', search);
      }
    }, 400);

    return () => {
      clearTimeout(searchDelay);
    };
  }, [search]);

  useEffect(() => {
    if (params.get('search')) {
      setSearch(params.get('search'));
    }
  }, []);

  return (
    <InputWrapper {...wrapperProps}>
      <SearchInput
        state={search}
        setState={setSearch}
        alwaysExpand={alwaysExpand}
        searchSize={searchSize}
        className={className}
        fullWidth={fullWidth}
        disabled={disabled}
      />
    </InputWrapper>
  );
};

export default Searchbar;
